import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { certificacoesService } from '../../services';
import { Certificacao } from '../../types/aquisicao';

const fields: ResourceField<Certificacao>[] = [
  { name: 'codigo', label: 'Código', required: true },
  { name: 'descricao', label: 'Descrição', required: true },
];

export const CertificacoesFormPage: React.FC = () => (
  <ResourceFormPage
    title="Certificação"
    description="Cadastro de certificações disponíveis para fornecedores."
    fields={fields}
    service={certificacoesService}
    redirectPath="/admin/aquisicao/certificacoes"
    cancelPath="/admin/aquisicao/certificacoes"
  />
);

export default CertificacoesFormPage;
